import angular from 'angular';

angular.module('cxRelations', ['commonServices']);
